<template>
    <div class="list-group-item text-danger" @click="handleLogout">
        <div class="row align-items-center">
            <div class="col">
                <h4 class="mb-1">
                    Sair
                </h4>
            </div>
        </div>
    </div>
    <ConfirmModal
        title="Sair"
        message="Deseja deslogar de sua conta?"
        confirmText="Sair"
        @onAction="handleConfirmAction"
    />
</template>
<script lang="ts" setup>
import ConfirmModal from '@/components/Modals/ConfirmModal.vue';
import useModals from '@/components/Modals/useModals';
import { ConfirmModalResponse } from '@/components/Modals/modals.types';
import { EModal } from '@/enums';
import paths from '@/router/paths';
import { useRouter } from 'vue-router';

const router = useRouter()
const { toggleModal } = useModals()

const handleLogout = () => {
    toggleModal(EModal.confirm)
}

const handleConfirmAction = (action: ConfirmModalResponse) => {
    if (action === 'confirm') {
        router.push(paths.login)
    }
}
</script>